import React, { useState } from 'react';
import './Gallery.css';

// Import gallery images
import img0 from '../assets/images/gallery_images/0.jpg';
import img1 from '../assets/images/gallery_images/1.jpg';
import img2 from '../assets/images/gallery_images/2.jpg';
import img3 from '../assets/images/gallery_images/3.jpg';
import img4 from '../assets/images/gallery_images/4.jpg';
import img5 from '../assets/images/gallery_images/5.jpg';
import img6 from '../assets/images/gallery_images/6.jpg';
import img7 from '../assets/images/gallery_images/7.jpg';
import img8 from '../assets/images/gallery_images/8.jpg';

const Gallery: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const galleryImages = [
    { id: 0, src: img0, alt: 'Modern Office Space' },
    { id: 1, src: img1, alt: 'Collaborative Workspace' },
    { id: 2, src: img2, alt: 'Private Office' },
    { id: 3, src: img3, alt: 'Meeting Room' },
    { id: 4, src: img4, alt: 'Common Area' },
    { id: 5, src: img5, alt: 'Kitchen Facilities' },
    { id: 6, src: img6, alt: 'Reception Area' },
    { id: 7, src: img7, alt: 'Work Environment' },
    { id: 8, src: img8, alt: 'Office Interior' },
  ];

  const openLightbox = (imageSrc: string) => {
    setSelectedImage(imageSrc);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <div className="section-header">
          <h2>Gallery</h2>
          <p>Take a look at our modern workspace and facilities</p>
        </div>

        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div 
              key={image.id} 
              className="gallery-item"
              onClick={() => openLightbox(image.src)}
            >
              <img 
                src={image.src} 
                alt={image.alt}
                loading="lazy"
              />
              <div className="gallery-overlay">
                <span className="zoom-text">View Image</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content">
            <button className="close-lightbox" onClick={closeLightbox}>
              ×
            </button>
            <img 
              src={selectedImage} 
              alt="Enlarged view" 
              onClick={(e) => e.stopPropagation()} 
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;